var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
    "dismiss": `Lukk`
};


export {$9f576b39d8e7a9d6$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
